import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import React from "react";
import { MenuItem } from "./MenuItem";
import "./Styles.scss";

export class Menu extends BaseComponent<IMenuProps, IMenuState>
{
    private menuRef: React.RefObject<HTMLUListElement | null> = React.createRef();

    public componentDidMount(): void
    {
        this.checkChildren();
        this.handleAnchorChange();
    }

    public componentDidUpdate(prevProps: IMenuProps): void
    {
        if (prevProps.children != this.props.children)
        {
            this.checkChildren();
        }
        if (prevProps.anchor != this.props.anchor)
        {
            this.handleAnchorChange();
        }
        if (!prevProps.open && this.props.open)
        {
            this.handleOpen();
        }
    }

    public checkChildren(): void
    {
        const children = React.Children.toArray(this.props.children);
        const childrenAreValid = children.every(i => React.isValidElement(i) && i.type === MenuItem);

        if (!childrenAreValid)
        {
            throw new Error('Menu must contain only MenuItems.');
        }
    }

    private handleAnchorChange(): void
    {
        this.setPosition();
    }

    private handleOpen(): void
    {
        this.setPosition();
    }

    private setPosition(): void
    {
        const menu = this.menuRef.current;
        if (!menu)
        {
            return;
        }

        if (this.props.anchor)
        {
            const rect = this.props.anchor.getBoundingClientRect();
            menu.style.top = `${rect.bottom}px`;
            menu.style.left = `${rect.left}px`;
        }
        else
        {
            menu.style.top = '';
            menu.style.left = '';
        }
    }

    public render(): JSX.Element
    {
        const cssClasses: string[] = [];
        cssClasses.push('context-menu');
        cssClasses.push(this.props.className);
        cssClasses.push(this.props.open ? 'context-menu--open' : '');

        return (
            <div
                className={cssClasses.filter(i => !!i).join(' ')}
            >
                <div
                    className='context-menu__mask'
                    onClick={() => this.props.onClose()}
                />
                <ul
                    ref={this.menuRef}
                    className='context-menu__menu'
                >
                    {this.props.children}
                </ul>
            </div>
        );
    }
}

export interface IMenuProps
{
    anchor: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    children: ReactNode;
    className: string;
}

export interface IMenuState { }
